import React, { HTMLAttributes } from 'react';
import c from 'classnames';
import s from './InputFieldOutline.scss';

interface Props extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  /**
   * Determines the color and behaviour of the outline.
   *
   * Not passing this prop produces the default outline color and behaviour: A gray color that turns green on focus and hover.
   *
   * The others behave as follows.
   * `success`: Green outline, continues to be green on focus and hover
   * `error`: Red outline, continues to be red on focus and hover
   * `disabled`: Removes the outline and adds a grey background.
   */
  outlineStyle?: 'success' | 'error' | 'disabled';
}

/** The outline and background for our input fields.  */
const InputFieldOutline = React.forwardRef<HTMLDivElement, Props>(
  ({ outlineStyle, className, children, ...rest }, ref) => {
    return (
      <div
        ref={ref}
        className={c(
          s['root'],
          outlineStyle === 'success' && s['success'],
          outlineStyle === 'error' && s['error'],
          outlineStyle === 'disabled' && s['disabled'],
          className
        )}
        {...rest}
      >
        {children}
      </div>
    );
  }
);
InputFieldOutline.displayName = 'InputFieldOutline';

export default InputFieldOutline;
